var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"modaluppy"}},[_c('div',{ref:"overlay",staticClass:"uppy",class:{ hidden: !_vm.dataShow },on:{"click":_vm.onClickOverlay}},[_c('div',{staticClass:"overlay-dashboard"},[_c('button',{staticClass:"close",attrs:{"id":"closeUppy"},on:{"click":_vm.close}})]),_c('div',{staticClass:"DashboardContainer"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }